export const compareArrays = (firstArray: any[], secondArray: any[]): boolean => {
  return (firstArray.length === secondArray.length) &&
    firstArray.every((value, index) => value === secondArray[index])
}

// -- The function should return an array of unique sorted string values.
export const getUniqueArrayParams = (arr1: string[], arr2: string[]): string[] => {
  const combinedArray = [...arr1, ...arr2]
  const countMap: Record<string, number> = {}

  combinedArray.forEach((item) => {
    countMap[item] = (countMap[item] || 0) + 1
  })

  const uniqueValuesArray = combinedArray.filter((item) => countMap[item] === 1)

  uniqueValuesArray.sort()

  return uniqueValuesArray
}

export const isFullArray = (value: any): boolean => Array.isArray(value) && value.length > 0

export const mergeArrays = (arr1: any[], arr2: any[], maxArrSize: number): { accepted: any[], rejected: any[] } => {
  const combinedArray = arr1.concat(arr2)
  const acceptedArray = combinedArray.slice(0, maxArrSize)
  const rejectedArray = combinedArray.slice(maxArrSize)

  return {
    accepted: acceptedArray,
    rejected: rejectedArray,
  }
}
